import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=1d7a1208&scoped=true"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=1d7a1208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7a1208",
  null
  
)

export default component.exports